define([
    'text!index2021-home/component/page-content.html',
    'index2021-home/common/api',
    'jquery',
    '../common/utils',
    'inView',
    'index2021-home/component/image-slick',
    '../../../../vendor/slick/slick.js',
    // 'index2020/component/image-slick',
    // 'index2020/component/image-float',
    // 'index2020/component/line-con',
    'css!index2021-home/component/page-content.css',
    'css!vendor/slick/slick.css',
    'css!vendor/slick/slick-theme.css',
    'css!index2020/component/image-slick.css'
], function(
    tpl,
    Api,
    $,
    Utils,
    inView,
    ImageSlick
    // ImageFloat,
    // LineCon
){
    return {
        template: tpl,
        components: {
            ImageSlick: ImageSlick
            // ImageFloat: ImageFloat,
            // LineCon: LineCon
        },
        data: function(){
            return {
                itemHeight: 0,
                isPC: true,

                atHomeIndex: 0,
                visitIndex: 0,
                atHome: [],
                visitList: [],
                homeInfo: {},
                isZh: true,
                homeImg: '',
                homeList: [],
                itemInfo: [
                    {nameLeft: 'FINE GOOD',nameRight: '好物合集'},
                    {nameLeft: 'NEW ARRIVAL',nameRight: '新品推荐'},
                    {nameLeft: 'RECOMMEND',nameRight: '推荐合集'}
                ],
                type: 1
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    _this.homeInfo = _this.$i18n.messages.en.homeInfo;
                }else {
                    _this.isZh = true;
                    _this.homeInfo = _this.$i18n.messages.zh.homeInfo;
                }
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                _this.itemHeight = ($(window).width()/100*96)/1000*225;
            },
            slickInfo: function(){
                var _this = this;
                _this.$nextTick(function () {
                    $('.home-slick').slick({
                        pauseOnHover: true,
                        autoplay: true,
                        fade: true,
                        infinite: true,
                        accessibility: false,
                        arrows: false
                    });

                    $('#atHome-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $('#atHome-slick').find('img').css("width","");
                        $('#visit-slick').find('img').css("width","");
                    });
                    $('#visit-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $('#atHome-slick').find('img').css("width","");
                        $('#visit-slick').find('img').css("width","");
                    });
                    $('#atHome-slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
                        _this.atHomeIndex = currentSlide;
                    });
                    $('#visit-slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
                        _this.visitIndex = currentSlide;
                    });
                })
            },
            getImages: function(){
                var _this = this;
                // console.log(Utils.getUrlKey("id"));
                _this.type = Utils.getUrlKey("type");
                Api.getMagazineJson.ajax({id:Utils.getUrlKey("id")})
                    .done(function(data){
                        _this.homeImg = data.brandImg;
                        _this.homeList = data.brandGoods;
                        _this.$set(_this.homeList,_this.homeList);
                        if(_this.isPC){
                            _this.slickInfo();
                        }
                    });
            },
            toAtHomeInfo: function(id) {
                window.open("/fnjihome-detail?id="+id);
            },
            toVisitInfo: function(id) {
                window.open("/fnjidrop-detail?id="+id);
            },
            initAnimate: function(){
                var selector = '.index-cell';
                inView(selector)
                    .on('enter', function(el){
                        $(el).css({
                            transform: 'translateY(0)'
                        });
                    })
                    .on('exit', function(el){
                        var rect = el.getBoundingClientRect();
                        var ty = rect.top > 0 ? 80 : -80;
                        $(el).css({
                            transform: 'translateY('+ty+'px)'
                        });
                    });
                $(selector).each(function(){
                    inView(selector).emit('exit', this);
                });
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            },
            atHomeIndex: function () {
                $( "#atHome-slick" ).slick( 'slickGoTo', this.atHomeIndex, false);
            },
            visitIndex: function () {
                $( "#visit-slick" ).slick( 'slickGoTo', this.visitIndex, false);
            }
        },
        mounted: function(){
            this.init();
            this.getImages();
            // this.initAnimate();
            // Utils.emitPageReady();
            var obj = this;
            $('.fixed-menu').css({display: 'none'});
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                    obj.itemHeight = ($(window).width()/100*96)/1000*225;
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-home/component/page-content.js
// module id = 267
// module chunks = 6